module.exports = __webpack_public_path__ + "img/star-l-8dc114.6413e0ac.svg";